import React, { useEffect, useState } from "react";
import { Container, DefaultSwitch } from "../../CreateWheelPopup.styled";
import TextView from "../../../TextView";
import IyugaTooltip from "../../../IyugaTooltip";
import { Box, Stack, Switch } from "@mui/material";
import BroadCastButton from "../../../LiveCloneComponents/BroadCastButton";
import { ASSETS } from "../../../../utils/config";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsClonable,
  setIsLive,
} from "../../../../redux/reducers/segmentBuilder";
function Fourth() {
  const dispatch = useDispatch();
  // State for toggles
  const [isWheelClonable, setIsWheelClonable] = useState(false);
  const [isLiveClone, setIsLiveClone] = useState(false);
  const wheelInformation = useSelector((state) => state.segmentBuilder);

  const handleCanBeClonedChange = (event) => {
    const isChecked = event.target.checked;
    setIsWheelClonable(isChecked);
    dispatch(setIsClonable(isChecked));

    // If cloneable is turned off, automatically turn off and disable Sync Clones
    if (!isChecked) {
      setIsLiveClone(false);
      dispatch(setIsLive(false));
    }
  };

  const handleLiveCloneUpdate = (event) => {
    setIsLiveClone(event.target.checked);
    dispatch(setIsLive(event.target.checked));
  };

  useEffect(() => {
    // dispatch(setIsClonable(wheelInformation?.history[wheelInformation?.currentIndex]?.is_clonable));
    setIsWheelClonable(
      wheelInformation?.history[wheelInformation?.currentIndex]?.is_clonable
    );
    setIsLiveClone(
      wheelInformation?.history[wheelInformation?.currentIndex]?.is_live
    );

    // dispatch(setIsLive(wheelInformation?.history[wheelInformation?.currentIndex]?.is_live));
  }, []);

  return (
    <Container>
      {/* Title */}
      <TextView variant="title" style={{ textAlign: "center" }}>
        Can it be cloned?
      </TextView>

      {/* Subtitle */}
      <TextView variant="subtitle" style={{ marginTop: "24px" }}>
        Cloning lets fans of your Wheel copy it and share it with the world!
        Don't worry, you'll always be credited as the original creator.
      </TextView>

      {/* Toggles Section */}
      <Stack
        mt={2}
        direction="column"
        sx={{ marginTop: "10px", marginBottom: "15px" }}
      >
        {/* "Can be Cloned" toggle */}
        <Box display="flex" alignItems="center">
          <DefaultSwitch
            checked={isWheelClonable}
            onChange={handleCanBeClonedChange}
          />
          <TextView
            variant="subtitle"
            style={{
              margin: "0 8px 0 4px",
            }}
          >
            Cloneable
          </TextView>
          <IyugaTooltip
            placement="right"
            tooltip={
              <TextView
                style={{
                  fontWeight: "200",
                  color: "#123051",
                  fontSize: "12px",
                }}
              >
                Clones can be Synced or Static: <br /> • Synced Clones :
                Automatically updated by the Original Creator via{" "}
                <BroadCastButton size="small" />
                . Cannot be edited.
                <br /> • Static Clones : Editable copies of the Original. Edits
                create a new version, leaving the original Clone unchanged for
                reuse.
              </TextView>
            }
          />
        </Box>

        {/* "Live Clone Updates" toggle */}
        <Box display="flex" alignItems="center">
          <DefaultSwitch
            checked={isLiveClone}
            onChange={handleLiveCloneUpdate}
            disabled={!isWheelClonable}
          />
          <TextView
            variant="subtitle"
            style={{
              margin: "0 8px 0 4px",
            }}
          >
            Sync Clones
          </TextView>
          <IyugaTooltip
            placement="right"
            tooltip={
              <TextView
                style={{
                  fontWeight: "200",
                  color: "#123051",
                  fontSize: "12px",
                }}
              >
                If enabled, Clones of this Wheel will be ‘Sync Clones’. <b />
                Sync Clones are connected to the Original and will be
                automatically updated after pressing{" "}
                <BroadCastButton size="small" /> in the header.
                <br /> Sync Clones cannot be edited by anyone other than the
                original creator.
              </TextView>
            }
          />
        </Box>
      </Stack>

      {/* Disclaimer - only show if both Cloneable and Sync Clones are enabled */}
      {isWheelClonable && isLiveClone && (
        <Box
          sx={{
            width: "100%",
            borderRadius: "12px",
            border: "1px solid #F79A00",
            padding: "16px",
            backgroundColor: "#F79A001A",
            marginTop: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
          }}
        >
          <TextView
            style={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0%",
              color: "#565556",
            }}
          >
            Other Users can only edit clones if "Sync Clones" is turned off.
          </TextView>
        </Box>
      )}
    </Container>
  );
}

export default Fourth;
